import React from 'react';
import useApi from './useApi';
import { LS_KEYS } from '../hooks';

const BASE_URL = '/hour';

export const useHour = () => {
  const { post, get } = useApi(LS_KEYS.BACKOFFICE);
  const { get: getHoursSite } = useApi(LS_KEYS.SITE);

  /**
   * Load work hours
   */
  const load = React.useCallback(async () => {
    const loadedData = await get(BASE_URL);

    const { data, isOpen } = loadedData;

    return {
      data,
      isOpen,
    };
  }, [get]);

  /**
   * Load work hours for use in site
   */
  const loadHoursSite = React.useCallback(async () => {
    const loadedData = await getHoursSite(BASE_URL);

    const { data, isOpen } = loadedData;

    return {
      data,
      isOpen,
    };
  }, [getHoursSite]);

  /**
   * Create work hours
   */
  const create = React.useCallback(
    async data => {
      const createdData = await post(BASE_URL, data);
      return createdData && createdData.data
        ? JSON.parse(createdData.data)
        : null;
    },
    [post],
  );

  return { load, create, loadHoursSite };
};

export default useHour;
